const { createContext } = require("react");

const JointAccountContext = createContext();

export default JointAccountContext;
